const BASE =
  process.env.REACT_APP_API_URL ||
  "https://lightslategrey-mole-360881.hostingersite.com/api";

export async function adminFetch(endpoint, options = {}) {
  const token = localStorage.getItem("kkb_token");

  // console.log(`📡 Admin API call: ${endpoint}`);

  if (!token) {
    console.error("No token found in localStorage!");
    throw new Error("No authentication token found. Please login again.");
  }

  const headers = {
    Authorization: `Bearer ${token}`,
    ...(options.body && !(options.body instanceof FormData)
      ? { "Content-Type": "application/json" }
      : {}),
  };

  const cfg = {
    headers,
    credentials: "include",
    ...options,
  };

  if (
    cfg.body &&
    typeof cfg.body === "object" &&
    !(cfg.body instanceof FormData)
  ) {
    cfg.body = JSON.stringify(cfg.body);
  }

  try {
    // For upload endpoints, use /api/upload not /api/admin/upload
    let url = `${BASE}${endpoint}`;
    if (!endpoint.startsWith("/upload") && !endpoint.startsWith("/admin")) {
      url = `${BASE}/admin${endpoint}`;
    } else if (endpoint.startsWith("/upload")) {
      url = `${BASE}${endpoint}`;
    }

    // console.log(`Fetching URL: ${url}`);
    const res = await fetch(url, cfg);

    if (res.status === 401) {
      localStorage.removeItem("kkb_token");
      localStorage.removeItem("kkb_user");
      throw new Error("Session expired. Please login again.");
    }

    const contentType = res.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Request failed");
      return data;
    } else {
      const text = await res.text();
      console.error("Non-JSON response:", text.substring(0, 200));
      throw new Error("Server returned an error page");
    }
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
}

export async function uploadFetch(endpoint, options = {}) {
  const token = localStorage.getItem("kkb_token");
  const isFormData = options.body instanceof FormData;

  const headers = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    // Add Content-Type for JSON bodies (not FormData)
    ...(!isFormData && options.body
      ? { "Content-Type": "application/json" }
      : {}),
  };

  // Don't set Content-Type for FormData - browser will set it with boundary
  const cfg = {
    headers,
    credentials: "include",
    // mode: "cors", // Explicitly set CORS mode
    ...options,
  };

  try {
    // Ensure endpoint starts with /upload
    let url = `${BASE}${endpoint.startsWith("/") ? endpoint : "/" + endpoint}`;

    // If endpoint is already full, don't modify
    if (!endpoint.startsWith("/upload")) {
      url = `${BASE}/upload/${endpoint.replace(/^\/+/, "")}`;
    }

    console.log(`Upload URL: ${url}`);

    const res = await fetch(url, cfg);

    // console.log(`Upload response status: ${res.status}`);

    if (res.status === 401) {
      localStorage.removeItem("kkb_token");
      localStorage.removeItem("kkb_user");
      throw new Error("Session expired. Please login again.");
    }

    const contentType = res.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Upload failed");
      return data;
    } else {
      const text = await res.text();
      console.error("Non-JSON response from upload:", text.substring(0, 200));
      throw new Error("Server returned an error page");
    }
  } catch (error) {
    console.error("Upload fetch error:", error);
    throw error;
  }
}

export const aGet = (url, params = {}) => {
  const qs = new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== ""),
    ),
  ).toString();
  return adminFetch(`${url}${qs ? "?" + qs : ""}`);
};

export const aPost = (url, body, customOptions = {}) => {
  if (
    body instanceof FormData &&
    (url.includes("/upload/") ||
      url === "/upload/product-image" ||
      url === "/upload/product-images")
  ) {
    // For uploads, use the uploadFetch which doesn't add /admin prefix
    return uploadFetch(url, { method: "POST", body, ...customOptions });
  }
  return adminFetch(url, { method: "POST", body, ...customOptions });
};

export const aPut = (url, body) => adminFetch(url, { method: "PUT", body });

export const aDelete = (url, body) => {
  if (url.includes("/upload/")) {
    const options = body
      ? { method: "DELETE", body: JSON.stringify(body) }
      : { method: "DELETE" };
    return uploadFetch(url, options);
  }
  const options = body ? { method: "DELETE", body } : { method: "DELETE" };
  return adminFetch(url, options);
};
